module.exports = __webpack_public_path__ + "img/nav.8e7b65e4.png";